module.exports = __webpack_public_path__ + "static/media/delete.dc1e3869.png";